import React, { useState } from 'react';
import Modal from '../../../components/Modal'; // আপনার আগের Modal কম্পোনেন্ট
import { useAuth } from '../../../hooks/useAuth'; 
import moment from 'moment'; // npm install moment (যদি না থাকে)

const VITE_API_URL = import.meta.env.VITE_API_URL;

const DoctorDetailsModal = ({ isOpen, onClose, doctor, details }) => {
    const { token } = useAuth();
    const [months, setMonths] = useState(1);
    const [loading, setLoading] = useState(false);

    // মডাল হ্যান্ডলার
    const handleExtendSubscription = async () => {
        if (!confirm(`Confirm cash payment received? extending for ${months} months?`)) return;

        setLoading(true);
        try {
            const res = await fetch(`${VITE_API_URL}/admin/doctors/${doctor.doctor_id}/subscription`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    months: parseInt(months),
                    plan_type: parseInt(months) >= 12 ? 'yearly' : 'monthly'
                })
            });

            const data = await res.json();

            if (res.ok) {
                alert("Subscription Extended Successfully!");
                window.location.reload(); // পেজ রিফ্রেশ দেবে যাতে নতুন ডেট দেখা যায়
            } else {
                alert(data.message || "Failed to update");
            }
        } catch (error) {
            console.error(error);
            alert("Network Error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={doctor?.full_name}>
            <div className="space-y-6 text-gray-800">
                
                {/* --- 1. Basic Info (Previous Code) --- */}
                <div className="flex gap-4 items-center p-4 bg-indigo-50 rounded-lg border border-indigo-100">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-3xl shadow-sm">
                        👨‍⚕️
                    </div>
                    <div>
                        <h4 className="font-bold text-lg text-indigo-900">{doctor?.full_name}</h4>
                        <p className="text-sm text-gray-600">{doctor?.email}</p>
                        <p className="text-sm text-gray-600">Phone:{doctor?.phone_number}</p>
                        <span className={`text-xs px-2 py-0.5 rounded font-bold uppercase ${doctor?.status === 'active' ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'}`}>
                            {doctor?.status}
                        </span>
                    </div>
                </div>

                {/* --- 2. Subscription Manager (NEW ADDITION) --- */}
                <div className="bg-white border border-gray-300 rounded-lg p-4 shadow-sm">
                    <h5 className="font-bold text-gray-700 border-b pb-2 mb-3 flex justify-between">
                        <span>💳 Subscription Status</span>
                        <span className={`text-xs px-2 py-1 rounded ${doctor?.subscription_status === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                            {doctor?.subscription_status?.toUpperCase()}
                        </span>
                    </h5>
                    
                    <div className="flex justify-between items-center mb-4 text-sm">
                        <span className="text-gray-500">Current Plan Expires:</span>
                        <span className="font-mono font-bold text-indigo-600">
                            {doctor?.subscription_end_date 
                                ? moment(doctor.subscription_end_date).format('DD MMM YYYY') 
                                : 'N/A'}
                        </span>
                    </div>

                    {/* Manual Renewal Form */}
                    <div className="bg-gray-50 p-3 rounded border border-gray-200">
                        <label className="text-xs font-bold text-gray-500 uppercase block mb-2">
                            Manual Renewal (Cash Payment)
                        </label>
                        <div className="flex gap-2">
                            <select 
                                value={months} 
                                onChange={(e) => setMonths(e.target.value)}
                                className="flex-1 border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-indigo-500"
                            >
                                <option value="1">1 Month</option>
                                <option value="3">3 Months</option>
                                <option value="6">6 Months</option>
                                <option value="12">1 Year (12 Months)</option>
                            </select>
                            <button 
                                onClick={handleExtendSubscription}
                                disabled={loading}
                                className={`px-4 py-2 rounded text-sm font-bold text-white transition ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'}`}
                            >
                                {loading ? 'Saving...' : 'Confirm'}
                            </button>
                        </div>
                    </div>
                </div>

                {/* --- 3. Key Metrics (Previous Code) --- */}
                <div className="grid grid-cols-2 gap-4">
                    <div className="bg-gray-50 p-4 rounded border border-gray-200 text-center">
                        <div className="text-xs text-gray-500 uppercase font-bold tracking-wide">Total Prescriptions</div>
                        <div className="text-3xl font-extrabold text-gray-900 mt-2">{details ? details.rx_count : '...'}</div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded border border-gray-200 text-center">
                        <div className="text-xs text-gray-500 uppercase font-bold tracking-wide">Staff Members</div>
                        <div className="text-3xl font-extrabold text-gray-900 mt-2">{details ? details.staff_count : '...'}</div>
                    </div>
                </div>

                <div className="text-xs text-gray-400 text-center pt-2">
                    Registered on: {new Date(doctor?.created_at).toLocaleDateString()}
                </div>
            </div>
        </Modal>
    );
};

export default DoctorDetailsModal;